import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/alert/close.svg';
const AlertCloseSvg = () => React.createElement(IconSvg, null);
export default AlertCloseSvg;
